// Crockford-base32 ULID, sortable by creation time, generated with WebCrypto.
// 26 characters: 10 timestamp + 16 random.

const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export function ulid(now: number = Date.now()): string {
  let timeChars = '';
  let t = now;
  for (let i = 9; i >= 0; i--) {
    timeChars = CROCKFORD[t % 32] + timeChars;
    t = Math.floor(t / 32);
  }
  const randomBytes = new Uint8Array(10);
  crypto.getRandomValues(randomBytes);
  let randomChars = '';
  let bits = 0;
  let value = 0;
  for (let i = 0; i < randomBytes.length; i++) {
    value = (value << 8) | randomBytes[i]!;
    bits += 8;
    while (bits >= 5) {
      randomChars += CROCKFORD[(value >>> (bits - 5)) & 0x1f];
      bits -= 5;
    }
  }
  while (randomChars.length < 16) randomChars += '0';
  return timeChars + randomChars.slice(0, 16);
}
